import React from "react";

import { Col, Container, Row } from "react-bootstrap";

import { UserDisplay } from "@components/UserDisplay";
import { DocumentTable } from "@components/table/DocumentTable";

export const RecentReports = () => {
  return (
    <Container className="p-4" fluid>
      <Row className="pb-4">
        <Col>
          <UserDisplay />
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Recent reports submitted</h3>
        </Col>
      </Row>
      <DocumentTable />
    </Container>
  );
};
